export const formatPrice = (price: string | number) => {
  if (!price) return '€0,00';
  
  const value = typeof price === 'string' ? parseFloat(price) : price;
  
  return value.toLocaleString('pt-PT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
